import { css } from '@emotion/react';

export const styles = {
  container: css`
    width: 100%;
  `,
  actionsContainer: css`
    display: flex;
    justify-content: right;
  `,
  clearBtn: css`
    width: 100px;
  `
};
